import { isDelegated, getCustomerId, getDelegateCustomerId, getEmployeeId } from '@exp/exp-utils/helper/auth';
import VisitHelperTcc from '../../helpers/visitHelperTcc';

const visitHelper = new VisitHelperTcc();

const _keyFnMap = {
  'context.visitorId': ({ visitInfo }) => visitInfo.visitorGuid,
  'context.sessionId': ({ visitInfo }) => visitInfo.visitGuid,
  'context.customerId': () => getCustomerId(),
  'context.isDelegated': ({ delegated }) => delegated,
  'context.parent.customerId': ({ delegated }) => delegated ? getDelegateCustomerId() : undefined,
  'context.parent.agentId': ({ delegated }) => delegated ? getEmployeeId() : undefined
};

class GlobalContext {
  constructor() {
    this.context = {};
    this.version = 0;
  }

  init({ traceId }) {
    this.context = {
      traceId,
      context: {}
    };
  }

  updateContext() {
    const visitInfo = visitHelper.getVisitInfo();
    const delegated = isDelegated();

    let hasChanged = false;
    const newContext = {
      traceId: this.context.traceId
    };

    Object.entries(_keyFnMap).forEach(([path, fn]) => {
      const keys = path.split('.');

      const newValue = fn({ visitInfo, delegated });
      let existingValue;
      let propKey;

      let existingParent = this.context;
      let newParent = newContext;
      keys.forEach((key, index) => {
        if (index < keys.length - 1) {
          existingParent = existingParent[key] || {};
          newParent[key] = newParent[key] || {};
          newParent = newParent[key];
        } else {
          propKey = key;
          existingValue = existingParent[key];
        }
      });

      if (existingValue !== newValue) {
        hasChanged = true;
      }

      if (typeof newValue !== 'undefined') {
        newParent[propKey] = newValue;
      }
    });

    if (hasChanged) {
      this.version++;
      this.context = newContext;
    }
  }
}

const _globalContext = new GlobalContext();

export default _globalContext;
